import React, { useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { ErrorInpage } from '@hz-design-system/web-ui';

import BundleHero from './components/BundleHero';
import BundleSellingPoints from './components/BundleSellingPoints';
import BundleFeatures from './components/BundleFeatures';
import BundleQuote from './components/BundleQuote';
import BundleAdvantages from './components/BundleAdvantages';

import trackEvent from '../../utils/trackEvent';
import { BUNDLE_FREE_GET_PROFILE } from '../../constants/events';
import initiateOnboard from '../../services/onboard';
import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import { AppState, EnvironmentConfig } from '../../../../../types/AppState';

const LandingFreeBundle = ({ environment }: { environment: EnvironmentConfig; appState: AppState }) => {
  const i18n = useI18nContext();
  const isPending = false; // TODO: Temporary fix before prod lock. Fix ASAP.
  const [hasError, setHasError] = useState(false);
  const { loggedInUser, xsrfToken } = environment;

  const redirectToLogInScreen = () =>
    window.location.assign(`/account/login.html?target=${encodeURIComponent(window.location.href)}`);

  const attemptOnboard = async () => {
    try {
      await initiateOnboard({ xsrfToken });
      window.location.assign('/my-account/profile/smb/profile.html?notification=profileOnboarded');
    } catch {
      setHasError(true);
    }
  };

  const onCtaClick = async () => {
    trackEvent({ eventAction: BUNDLE_FREE_GET_PROFILE });
    if (!loggedInUser) {
      return redirectToLogInScreen();
    }
    await attemptOnboard();
  };

  return (
    <EnvironmentProvider value={environment}>
      <div className="hz-FreeBundle">
        <div className="hz-FreeBundle-section hz-FreeBundle-hero hz-FreeBundle-hero">
          <div className="hz-FreeBundle-container">
            <BundleHero isPending={isPending} onCtaClick={onCtaClick} />
            {hasError && (
              <ErrorInpage
                title={i18n.t('common.page.error.error_global_ajax')}
                icon="alert"
                className="u-marginTopL"
              />
            )}
          </div>
        </div>
        <div className="hz-FreeBundle-section hz-FreeBundle-section--noMobilePadding hz-FreeBundle-section--features">
          <div className="hz-FreeBundle-container">
            <BundleFeatures />
          </div>
        </div>
        {i18n.tExists('landingFreeBundle.quote.content') && (
          <div className="hz-FreeBundle-section hz-FreeBundle-section--gray">
            <div className="hz-FreeBundle-container">
              <BundleQuote />
            </div>
          </div>
        )}
        <div className="hz-FreeBundle-section hz-FreeBundle-section--noMobilePadding hz-FreeBundle-section--advantages">
          <div className="hz-FreeBundle-container">
            <BundleAdvantages />
          </div>
        </div>
        <div className="hz-FreeBundle-section" id="selling-points">
          <div className="hz-FreeBundle-container">
            <BundleSellingPoints isPending={isPending} onCtaClick={onCtaClick} />
          </div>
        </div>
      </div>
    </EnvironmentProvider>
  );
};

export default LandingFreeBundle;
